// extracted by mini-css-extract-plugin
export default {"cls1":"sy9p_KzxGbQJYxT3E4BS","cls2":"MEVAzHKwUhW0KhFHIN6G sy9p_KzxGbQJYxT3E4BS"};